import { delay } from "@/hooks/useReveal";

const QUESTIONS = [
  "What did we just send to that system?",
  "Where is the data stored, and were we allowed to put it there?",
  "On what basis did the AI give that answer?",
  "Who has access to the document?",
  "What must we be able to prove if someone asks tomorrow?",
];

export const SoundFamiliar = () => (
  <section className="section section--cream" aria-labelledby="qs-title" data-testid="sound-familiar-section">
    <div className="container split">
      <div className="stack" data-reveal>
        <p className="eyebrow">Sound familiar?</p>
        <h2 id="qs-title" className="title title--compact pains__title">How many new tools did your team start using this year?</h2>
        <p className="lead">ChatGPT for the first draft. AI to summarise a contract. A new invoicing system. Something a colleague found because it saves time. Each one enters the business in a minute. The questions come later.</p>
      </div>
      <div>
        <ol className="questions">
          {QUESTIONS.map((q, i) => (
            <li key={q} data-reveal style={delay(i, 60)}>
              <span className="questions__num">{String(i + 1).padStart(2, "0")}</span>
              <span className="questions__text">{q}</span>
            </li>
          ))}
        </ol>
        <p className="pains__close" data-reveal>None of these should stop a good tool. They need someone whose job it is to answer them.</p>
      </div>
    </div>
  </section>
);
